import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'android': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAndroid" */
        '@fortawesome/free-brands-svg-icons/faAndroid'
    ),
    'avianex': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAvianex" */
        '@fortawesome/free-brands-svg-icons/faAvianex'
    ),
    'bandcamp': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBandcamp" */
        '@fortawesome/free-brands-svg-icons/faBandcamp'
    ),
    'bitcoin': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBitcoin" */
        '@fortawesome/free-brands-svg-icons/faBitcoin'
    ),
    'bluesky': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBluesky" */
        '@fortawesome/free-brands-svg-icons/faBluesky'
    ),
    'bootstrap': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faBootstrap" */
        '@fortawesome/free-brands-svg-icons/faBootstrap'
    ),
    'centos': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCentos" */
        '@fortawesome/free-brands-svg-icons/faCentos'
    ),
    'creative-commons-sa': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCreativeCommonsSa" */
        '@fortawesome/free-brands-svg-icons/faCreativeCommonsSa'
    ),
    'css': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCss" */
        '@fortawesome/free-brands-svg-icons/faCss'
    ),
    'css3-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCss3Alt" */
        '@fortawesome/free-brands-svg-icons/faCss3Alt'
    ),
    'fort-awesome': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFortAwesome" */
        '@fortawesome/free-brands-svg-icons/faFortAwesome'
    ),
    'gg-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGgCircle" */
        '@fortawesome/free-brands-svg-icons/faGgCircle'
    ),
    'google': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGoogle" */
        '@fortawesome/free-brands-svg-icons/faGoogle'
    ),
    'google-play': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGooglePlay" */
        '@fortawesome/free-brands-svg-icons/faGooglePlay'
    ),
    'instalod': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faInstalod" */
        '@fortawesome/free-brands-svg-icons/faInstalod'
    ),
    'lastfm': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faLastfm" */
        '@fortawesome/free-brands-svg-icons/faLastfm'
    ),
    'reddit-alien': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faRedditAlien" */
        '@fortawesome/free-brands-svg-icons/faRedditAlien'
    ),
    'renren': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faRenren" */
        '@fortawesome/free-brands-svg-icons/faRenren'
    ),
    'shirtsinbulk': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faShirtsinbulk" */
        '@fortawesome/free-brands-svg-icons/faShirtsinbulk'
    ),
    'slack': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSlackHash" */
        '@fortawesome/free-brands-svg-icons/faSlackHash'
    ),
    'snapchat-ghost': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSnapchatGhost" */
        '@fortawesome/free-brands-svg-icons/faSnapchatGhost'
    ),
    'speaker-deck': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSpeakerDeck" */
        '@fortawesome/free-brands-svg-icons/faSpeakerDeck'
    ),
    'square-x-twitter': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareXTwitter" */
        '@fortawesome/free-brands-svg-icons/faSquareXTwitter'
    ),
    'twitch': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faTwitch" */
        '@fortawesome/free-brands-svg-icons/faTwitch'
    ),
    'weixin': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWeixin" */
        '@fortawesome/free-brands-svg-icons/faWeixin'
    ),
    'whatsapp': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWhatsapp" */
        '@fortawesome/free-brands-svg-icons/faWhatsapp'
    ),
    'wix': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWix" */
        '@fortawesome/free-brands-svg-icons/faWix'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>